import { Checkbox } from "@mui/material";
import { useCallback } from "react";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never }[keyof T];

export type TruxCheckboxFieldProps<T> = {
  modelSavingData: ModelSavingData<T>,
  field: KeysMatching<T, boolean>,
  onchange?: () => void,
  disabled?: boolean
}

export default function TruxCheckboxField<T>({ modelSavingData, field, onchange, disabled = false }: TruxCheckboxFieldProps<T>) {
  const currentValue = !!modelSavingData.model?.[field];

  const fieldOnChange = useCallback(() => {
    modelSavingData.update(data => {
      data[field] = !data[field] as any;
      onchange?.();
    });
  }, [modelSavingData, field, onchange]);

  return <Checkbox size="small" checked={currentValue as boolean} onChange={fieldOnChange} disabled={disabled} />
}